<template>
  <el-dialog title="选择商品"
             :visible.sync="goodsDialog"
             width="600px"
             style="text-align:left;"
             :close-on-click-modal="false"
             append-to-body
             class="big"
             :show-close="false">
    <div class="content">
      <div>
        <el-input v-model="keywords"
                  placeholder="请输入商品"
                  @input="inputSearch"
                  style="width:200px"></el-input>
        <el-button type="primary"
                   @click="getList"
                   style="margin-left:20px">查询</el-button>
      </div>
      <div class="list-box">

        <div class="flex align-center"
             v-for="item in goodsList"
             :key="item.goods_id">
          <el-checkbox v-model="item.checked"></el-checkbox>
          <img :src="item.picture"
               alt />
          <div>{{item.goods_name}}</div>
          <div><span>原价: {{ item.price }}元 </span> <span> 会员价: {{ item.member_price }}元</span></div>
        </div>

        <div v-show="!goodsList.length"
             style="text-align: center;">暂无搜索结果</div>
      </div>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary"
                 @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import common from '../../../../api/common.js';
export default {
  data() {
    return {
      keywords: '',
      goodsDialog: true,
      goodsList: []
    };
  },
  methods: {
    inputSearch() {
      if (!this.keywords) {
        this.goodsList = [];
        return false;
      }
      this.getList();
    },
    getList() {
      if (!this.keywords) {
        this.$message.error('请输入商品信息！');
        return false;
      }
      common
        .getShopActivityGoodsList({ keywords: this.keywords })
        .then((res) => {
          let list = res.data.list;
          list.forEach((ele) => {
            ele.checked = false;
          });
          this.goodsList = list;
        });
    },
    close() {
      this.$emit('close');
    },
    submit() {
      let list = this.goodsList.filter((ele) => {
        return ele.checked;
      });
      this.$emit('confirmGoods', list);
      this.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 30px 30px 0;
  box-sizing: border-box;
}
.list-box {
  height: 400px;
  overflow: auto;
  margin-top: 15px;
  & > div {
    margin-bottom: 10px;
  }
  img {
    height: 70px;
    width: auto;
    margin: 0 15px;
  }
}
</style>
